if (!customElements.get('bionilo-cookie-notice')) {
  customElements.define(
    'bionilo-cookie-notice',
    class BioniloCookieNotice extends HTMLElement {
      constructor() {
        super();

        this.initialized = false;
        this.init();
      }

      get delay() {
        const value = parseInt(this.getAttribute('data-delay'), 10);
        return Number.isFinite(value) ? value : 5;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get acceptButton() {
        return this.querySelector('[data-cookie-accept]');
      }

      get declineButton() {
        return this.querySelector('[data-cookie-decline]');
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        this.acceptButton?.addEventListener(
          'click',
          () => this.accept()
        );

        this.declineButton?.addEventListener(
          'click',
          () => this.decline()
        );

        if (this.testMode) {
          this.scheduleShow();
          return;
        }

        if (
          window.Shopify &&
          typeof window.Shopify.loadFeatures === 'function'
        ) {
          window.Shopify.loadFeatures([
            {
              name: 'consent-tracking-api',
              version: '0.1',
              onLoad: () => this.checkConsent()
            }
          ]);
        }
      }

      scheduleShow() {
        setTimeout(
          () => this.showNotice(),
          this.delay * 1000
        );
      }

      checkConsent() {
        if (!window.Shopify?.customerPrivacy) return;

        const consent =
          window.Shopify.customerPrivacy.getTrackingConsent();

        if (consent === 'no_interaction') {
          this.scheduleShow();
        }
      }

      showNotice() {
        /*
         * Nur dieses Element sichtbar machen.
         *
         * KEIN:
         * body class
         * ModalElement
         * active
         * open
         * drawer
         * overlay
         * scroll lock
         */

        this.hidden = false;

        requestAnimationFrame(() => {
          this.classList.add('bcn-visible');
          this.setAttribute('aria-hidden', 'false');
        });
      }

      hideNotice() {
        this.classList.remove('bcn-visible');
        this.setAttribute('aria-hidden', 'true');

        setTimeout(() => {
          this.hidden = true;
        }, 180);
      }

      accept() {
        this.hideNotice();

        window.Shopify?.customerPrivacy?.setTrackingConsent(
          true,
          () => {}
        );
      }

      decline() {
        this.hideNotice();

        window.Shopify?.customerPrivacy?.setTrackingConsent(
          false,
          () => {}
        );
      }
    }
  );
}